// 2024(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import '../scss/style.scss';

import bootstrap from "~bootstrap/dist/js/bootstrap.bundle";
import * as template from "./template/template";
import * as dateInputRange from "./date-input-range";

import { schoolyear_select } from './schoolyear-select';
import { input_check_many } from './input-check-many';
import { input_select_tablerow } from './input-select-tablerow';

window.bootstrap = bootstrap;
window.schoolyear_select = schoolyear_select;
window.input_check_many = input_check_many;
window.input_select_tablerow = input_select_tablerow;

document.addEventListener("DOMContentLoaded", function() {
    
    let templateLoadTime = performance.now();

    template.init();

    dateInputRange.init();

    templateLoadTime = performance.now() - templateLoadTime;
    console.log('[EDUTIME] Template loaded in ' + templateLoadTime + 'ms.');

});